import { render } from "./defaulterSms.vue?vue&type=template&id=3d0282a3&scoped=true"
import script from "./defaulterSms.vue?vue&type=script&lang=js"
export * from "./defaulterSms.vue?vue&type=script&lang=js"

import "./defaulterSms.vue?vue&type=style&index=0&id=3d0282a3&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0282a3"]])

export default __exports__